const NotificationTypes = {
  GET_NOTIFICATION_LIST: 'GET_NOTIFICATION_LIST',
  UPDATE_SOCKET_NOTIFICATION: 'UPDATE_SOCKET_NOTIFICATION',
};

export default NotificationTypes;
